export default __webpack_public_path__ + "static/media/location-disclosure-map.cf7dba9d.png";